// extracted by mini-css-extract-plugin
module.exports = {"content":"SkillsBox_content__3DDv5"};